import { Outlet } from 'react-router-dom';

import { openModal } from 'enable-ui';

import { useAuthStore, userProfileSelector } from 'modules/auth/core';
import { RoleKey } from 'modules/auth/core/enum';
import { MODAL_KEY } from 'modules/auth/core/modal-key';
import { AddStationModal } from 'modules/institution-info/components/AddStationModal';

import { Container, Content, Menu, StyleIconArrow } from './styles/layout';

import { ReactComponent as IconArrowLeft } from 'assets/icons/chevrons-left.svg';
import { ReactComponent as IconArrowRight } from 'assets/icons/chevrons-right.svg';

import { checkRole } from 'helpers';
import { useBoolean } from 'hooks';

import { SidebarMenu } from './components/SidebarMenu';

export const MasterLayout = () => {
  const userProfile = useAuthStore(userProfileSelector);

  const isShowMenu = useBoolean(true);

  const isStation = userProfile?.institution?.isStation;

  if (checkRole([RoleKey.INSTITUTION_ADMIN]) && !isStation) {
    openModal(MODAL_KEY.ADD_STATION);
  }

  const handleToggleMenu = () => {
    isShowMenu.setValue(!isShowMenu.value);
  };

  return (
    <Container>
      <Menu style={isShowMenu.value ? { width: 240 } : { minWidth: 80, width: 80 }}>
        <SidebarMenu isShowMenu={isShowMenu.value} />
        <button className="btn-toggle-menu" onClick={handleToggleMenu}>
          <StyleIconArrow>
            {isShowMenu.value ? <IconArrowLeft /> : <IconArrowRight />}
          </StyleIconArrow>
        </button>
      </Menu>
      <Content id="content">
        <Outlet />
        <AddStationModal />
      </Content>
    </Container>
  );
};
